{
    "MQI_HD": {
        "name": "MQI_HD",
        "tooltip": "Model Quality Indicator - Hourly Resolution"
    },
    "MQI_YD": {
        "name": "MQI_YD",
        "tooltip": "Model Quality Indicator - Yearly Resolution"
    },
    "temporal.bias": {
        "name": "TN(Bias)",
        "tooltip": "Normalized Temporal Bias"
    },
    "temporal.1-R": {
        "name": "TN(1-R)",
        "tooltip": "Normalized Temporal Correlation (1-R)"
    },
    "temporal.std": {
        "name": "TN(SD)",
        "tooltip": "Normalized Temporal Standard Deviation"
    },
    "rur.season": {
        "name": "Rur(W-S)",
        "tooltip": "Seasonal Rural Score (Winter - Summer)"
    },
    "urb.season": {
        "name": "Urb(W-S)",
        "tooltip": "Seasonal Urban Score (Winter - Summer)"
    },
    "sub.season": {
        "name": "Sub(W-S)",
        "tooltip": "Seasonal Suburban Score (Winter - Summer)"
    },
    "rur.week": {
        "name": "Rur(Wk-We)",
        "tooltip": "Weekly Rural Score (Weekday - Weekend)"
    },
    "urb.week": {
        "name": "Urb(Wk-We)",
        "tooltip": "Weekly Urban Score (Weekday - Weekend)"
    },
    "sub.week": {
        "name": "Sub(Wk-We)",
        "tooltip": "Weekly Suburban Score (Weekday - Weekend)"
    },
    "rur.day": {
        "name": "Rur(D-N)",
        "tooltip": "Diurnal Rural Score (Day - Night)"
    },
    "urb.day": {
        "name": "Urb(D-N)",
        "tooltip": "Diurnal Urban Score (Day - Night)"
    },
    "sub.day": {
        "name": "Sub(D-N)",
        "tooltip": "Diurnal Suburban Score (Day - Night)"
    },
    "spatial.1-R": {
        "name": "SN(1-R)",
        "tooltip": "Normalized Spatial Correlation (1-R)"
    },
    "spatial.std": {
        "name": "SN(SD)",
        "tooltip": "Normalized Spatial Standard Deviation"
    },
    "ub-rb": {
        "name": "UB-RB",
        "tooltip": "UB-RB: Urban Background - Rural Background"
    }
}